module.exports = __webpack_public_path__ + "static/media/book-who-is-nemos-detail3.a4508eb4.jpg";